import axios from 'axios';
import { updateTicketExpiration } from './update-ticket-expiration';
import { getReqVerificationToken, getReqVerificationTokenHeaderKey } from './xsrf';

const axiosInstance = axios.create();

// Configure the axios instance's interceptors to send the XSRF token
axiosInstance.interceptors.request.use((request) => {
	const xsrfToken = getReqVerificationToken();

	if (xsrfToken != null) {
		const headerKey = getReqVerificationTokenHeaderKey();
		request.headers[headerKey] = xsrfToken;
	}

	return request;
});

// Configure the axios instance's interceptors to update the ticket expiration on response
axiosInstance.interceptors.response.use((response) => {
	const sessionExpiry = response.headers['x-session-expiry'];

	if (sessionExpiry != null) {
		updateTicketExpiration(sessionExpiry);
	}

	return response;
});

export default axiosInstance;
